import { __ } from "@wordpress/i18n";


export const paginationTypes = {
	none: {
		label: __("None", "pickplugins-product-slider-for-fluentcart"),
		value: "none"
	},
	normal: {
		label: __("Normal Pagination",
			"pickplugins-product-slider-for-fluentcart"), value: "normal"
	},
	ajax: {
		label: __("Ajax Pagination", "pickplugins-product-slider-for-fluentcart"),
		value: "ajax",
		isPro: true,
	},
	next_previous: {
		label: __("Next-Previous", "pickplugins-product-slider-for-fluentcart"),
		value: "next_previous",
		isPro: true,
	},
	loadmore: {
		label: __("Load More", "pickplugins-product-slider-for-fluentcart"),
		value: "loadmore",
		isPro: true,
	},
	infinite: {
		label: __("Infinite Load", "pickplugins-product-slider-for-fluentcart"),
		value: "infinite",
		isPro: true,
	},
	// filterable: {
	// 	label: __("Filterable", "pickplugins-product-slider-for-fluentcart"),
	// 	value: "filterable"
	// },
}